module.exports = __webpack_public_path__ + "img/sparking-change-grow.38e9c19d.png";